import { Button, Icon, Mascot } from '@viaja/design-system';
import type { ReactNode } from 'react';

/** Carregando: a Cris procurando (pose `buscar`, regra do DS). */
export function Loading({ label = 'Buscando…' }: { label?: string }) {
  return (
    <output className="app-center" aria-live="polite">
      <Mascot pose="buscar" size={140} label="" />
      <p className="body app-meta">{label}</p>
    </output>
  );
}

/** Erro de carregamento com tentativa de novo. */
export function LoadError({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div className="app-center" role="alert">
      <Mascot pose="ainda-nao" size={140} label="" />
      <p className="body">{message}</p>
      {onRetry ? (
        <Button variant="secondary" size="sm" onClick={onRetry}>
          Tentar de novo
        </Button>
      ) : null}
    </div>
  );
}

/** Aviso em linha (erro do formulário, limite de cota, falha da fonte). */
export function Notice({ children, tone = 'alert' }: { children: ReactNode; tone?: 'alert' | 'neutral' }) {
  return (
    <div
      className={tone === 'alert' ? 'app-notice small' : 'app-notice app-notice--neutral small'}
      role={tone === 'alert' ? 'alert' : undefined}
    >
      <Icon name="alerta" size={20} />
      <span>{children}</span>
    </div>
  );
}
